import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file TriggerGroup
 */
import { createOptionalContext } from '@tencent/glue-react-use';

var _createOptionalContex = createOptionalContext(),
    _createOptionalContex2 = _slicedToArray(_createOptionalContex, 2),
    TriggerGroupProvider = _createOptionalContex2[0],
    useTriggerGroup = _createOptionalContex2[1];

export { TriggerGroupProvider };
export var useTriggerGroupInstance = useTriggerGroup;